export default __webpack_public_path__ + "static/media/tischlereirubisch_2.759f12ca.jpg";